import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "src/services/commonLanguageHeader";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";

export type VehicleTypeSortDirection = "ASC" | "DESC";

export interface VehicleTypeListParams {
  page?: number;
  size?: number;
  sort?: VehicleTypeSortDirection;
  sortBy?: string;
}

export interface VehicleTypeRecord {
  id: string | number;
  name?: string;
  description?: string;
  active?: boolean | number | string;
  [key: string]: unknown;
}

export interface VehicleTypePayload {
  name: string;
  active: boolean;
  description?: string;
}

export interface VehicleTypePaginatedResponse {
  vehicleTypes?: VehicleTypeRecord[];
  data?: VehicleTypeRecord[];
  items?: VehicleTypeRecord[];
  content?: VehicleTypeRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
}

const replaceId = (url: string, id: string | number) =>
  url.replace("{id}", String(id));

export const getVehicleTypesList = (
  params: VehicleTypeListParams = {},
  language?: string,
) =>
  ApiService.get<{ response: VehicleTypePaginatedResponse }>(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.VEHICLE_TYPE.LISTING,
    {
      params,
      ...getLanguageHeaders(language),
    },
  );

export const createVehicleType = (
  payload: VehicleTypePayload,
  language?: string,
) =>
  ApiService.post(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.VEHICLE_TYPE.ADD,
    payload,
    getLanguageHeaders(language),
  );

export const updateVehicleType = (
  id: string | number,
  payload: Partial<VehicleTypePayload> & { id?: string | number },
  language?: string,
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.VEHICLE_TYPE.UPDATE, id),
    { id, ...payload },
    getLanguageHeaders(language),
  );

export const deleteVehicleType = (id: string | number, language?: string) =>
  ApiService.delete(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.VEHICLE_TYPE.DELETE, id),
    getLanguageHeaders(language),
  );
